import { CalendarDays, FileText, Users } from 'lucide-react';

import { TabsList, TabsTrigger } from '@/design-system/ui/Tabs';
import type { ScheduleEvent } from '@escala/domain/types';

/**
 * Abas do painel do evento para a equipe: Escala (o que já existia), Público do culto e
 * Resumo. O ponto âmbar avisa o culto que já aconteceu sem público registrado.
 */
export default function SheetTabs({ event, today }: { event: ScheduleEvent; today: string }) {
  const missing = !event.audience && event.date < today;

  return (
    <div className="border-b border-line-divider px-5 py-2.5">
      <TabsList aria-label="Seções do evento" className="w-full">
        <TabsTrigger value="escala" className="flex-1 justify-center text-center">
          <CalendarDays aria-hidden />
          Escala
        </TabsTrigger>
        <TabsTrigger value="publico" className="flex-1 justify-center text-center">
          <Users aria-hidden />
          Público
          {missing ? (
            <span className="size-2 rounded-full bg-accent-amber" title="Público não registrado">
              <span className="sr-only">(não registrado)</span>
            </span>
          ) : null}
        </TabsTrigger>
        <TabsTrigger value="resumo" className="flex-1 justify-center text-center">
          <FileText aria-hidden />
          Resumo
        </TabsTrigger>
      </TabsList>
    </div>
  );
}
